import { useState } from "react";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useAxios } from "../useAxios";
import { LevelDReportFilter } from "../../types/leveld-reports";

export function useExportLevelDReport() {
  const { t } = useTranslation();
  const axios = useAxios();
  const [isExporting, setIsExporting] = useState(false);

  const exportToExcel = async (filter: LevelDReportFilter) => {
    setIsExporting(true);
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
        format: "xlsx",
      });

      if (filter.examTermId) {
        params.append("examTermId", filter.examTermId);
      }
      if (filter.examId) {
        params.append("examId", filter.examId);
      }

      const response = await axios.get(`/api/leveldreports/export?${params}`, {
        responseType: "blob",
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      
      // Generate filename from dates
      const startDate = new Date(filter.startDate).toISOString().split("T")[0];
      const endDate = new Date(filter.endDate).toISOString().split("T")[0];
      link.setAttribute("download", `leveld-report-${startDate}-to-${endDate}.xlsx`);
      
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success(t("levelDReports.export.success"));
    } catch (error) {
      console.error("Export failed:", error);
      message.error(t("levelDReports.export.error"));
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    isExporting,
  };
}
